// extracted by mini-css-extract-plugin
export default {"AddPermissionTemplate":"AddPermissionTemplate_AddPermissionTemplate__4KDjd","body":"AddPermissionTemplate_body__Hlgkc","actions":"AddPermissionTemplate_actions__UShSx"};